import { render } from "./CNavigator.vue?vue&type=template&id=413e21b6&scoped=true&ts=true"
import script from "./CNavigator.vue?vue&type=script&lang=ts"
export * from "./CNavigator.vue?vue&type=script&lang=ts"

import "./CNavigator.vue?vue&type=style&index=0&id=413e21b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Silverfish-Vue/Silverfish-Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413e21b6"]])

export default __exports__